/**
 *
 * @class
 */
class XHR {


  private _getParamsString(baseUrl, object) {

    var encodedString = /\?/g.test(baseUrl) ? '&' : '?',
        i, l;


    // If baseUrl is omitted, this is params request for POST type xhr, se we can only return params
    if(!baseUrl) {
      encodedString = '';
    }

    if(!object) {
      return '';
    }

    for (var prop in object) {
      if (object.hasOwnProperty(prop)) {


        // if array
        if (typeof object[prop] === 'object' && object[prop].length) {
          for (i = 0, l = object[prop].length; i < l; i++) {
            if (encodedString.length > 1) {
              encodedString += '&';
            }

            encodedString += encodeURIComponent(prop + '[]') + '=' + encodeURIComponent(object[prop][i]);
          }
        } else {
          if (encodedString.length > 1) {
            encodedString += '&';
          }
          encodedString += encodeURIComponent(prop) + '=' + encodeURIComponent(object[prop]);
        }
      }
    }

    return encodedString;
  }

  /**
   * XHR Get
   * @param {string} url
   * @param {Object} params [optional]
   * @return {Promise<any>} result
   */
  public get(url:string, params?:Object) {
    var self = this;

    return new Promise<any>(function(resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', encodeURI(url) + self._getParamsString(url, params), true);
      xhr.onload = function() {
        if (xhr.status === 200) {
          resolve(JSON.parse(xhr.responseText));
        }
        else {
          reject(xhr.status);
        }
      };

      xhr.send();
    });
  }

  /**
   * XHR Post
   * @param {string} url
   * @param {Object} params [optional]
   * @return {Promise<any>} result
   */
  public post(url:string, params:Object) {
    var self = this;

    return new Promise<any>(function(resolve, reject) {
      var xhr = new XMLHttpRequest(),
          paramsString:string = self._getParamsString('', params);


      xhr.open('POST', encodeURI(url), true);

      //Send the proper header information along with the request
      xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

      xhr.onload = function() {
        if (xhr.readyState === 4  && xhr.status === 200) {
          resolve(JSON.parse(xhr.responseText));
        }
        else {
          reject(xhr.status);
        }
      };


      xhr.send(paramsString);

    });
  }
}

var xhr = new XHR();

export { xhr as XHR }
